import React from 'react';
import { Button } from './ui/button';
import { ArrowRight } from 'lucide-react';

const AuthCTA = ({ onSignUp, onSignIn }) => {
  return (
    <section className="border-t border-neutral-200 bg-neutral-50">
      <div className="mx-auto flex max-w-4xl flex-col items-center gap-6 px-6 py-16 text-center">
        <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-neutral-900 text-white">
          <svg viewBox="0 0 24 24" className="h-6 w-6" fill="currentColor">
            <path d="M12 2 L22 20 L2 20 Z" />
          </svg>
        </div>
        <div>
          <h2 className="font-serif text-3xl tracking-tight text-neutral-900 sm:text-4xl">
            Sign in to get started
          </h2>
          <p className="mt-2 text-neutral-600">Create an account or sign in to onboard your first AI worker.</p>
        </div>
        <div className="flex flex-col gap-3 sm:flex-row">
          <Button onClick={onSignUp} className="bg-neutral-900 text-white hover:bg-neutral-800">
            Sign up
            <ArrowRight className="ml-1.5 h-4 w-4" />
          </Button>
          <Button variant="outline" onClick={onSignIn} className="border-neutral-300 bg-white text-neutral-800 hover:bg-neutral-100">
            Sign in
          </Button>
        </div>
      </div>
    </section>
  );
};

export default AuthCTA;
